import { useCallback } from "react";

import AccountsMenuItem from "../components/AccountsMenuItem";

import type { SidebarRootItem } from "../sidebar.types";

/**
 * Hook that returns a builder for the accounts menu item.
 * The accounts section uses a fully custom sub-item renderer
 * (AccountsMenuItem) instead of standard SidebarOptionItem[].
 */
export const useAccountsMenuItem = () =>
  useCallback(
    (menuItem: API.SidebarMenuItem_Resolved): SidebarRootItem => ({
      ...menuItem,
      menuOptions: undefined,
      customMenuOptions: <AccountsMenuItem />,
    }),
    []
  );
